import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="integration--fancybox"
export default class extends Controller {
  async connect() {
    const token = (this.connectToken = {});
    const { Fancybox } = await import("@fancyapps/ui/dist/fancybox/");
    if (this.connectToken !== token) return;

    this.Fancybox = Fancybox;
    Fancybox.bind(this.element, "[data-fancybox]", {
      Hash: false,
      Carousel: {
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ["close"],
          },
        },
        Zoomable: {
          Panzoom: {
            maxScale: "cover",
            panMode: "mousemove",
            mouseMoveFactor: 1.1,
          },
        },
      },
      // Page videos would keep playing under the lightbox, and Chrome's GPU
      // video path can draw them over it; loop-video pauses them meanwhile.
      on: {
        init: () => this.dispatch("open", { prefix: "lightbox", target: window }),
        destroy: () => this.dispatch("close", { prefix: "lightbox", target: window }),
      },
    });
  }

  disconnect() {
    this.connectToken = null;
    this.Fancybox?.unbind(this.element);
    this.Fancybox?.close();
  }
}
